module.exports = __webpack_public_path__ + "static/media/FeedTime_web_3.593a69b3.jpg";